module.exports = __webpack_public_path__ + "media/images/howTo__numberLine--top-f68a4e32a36aa516a1e2a81937ada6bb.png";